module.exports = __webpack_public_path__ + "static/computer-small-3561f6b4b3d6e5f5e100a02796e75ea4.svg";